import {
    usePopupProps,
    usePopupReturnProps,
} from 'app/core/models/hook/usePopupProps'
import React from 'react'

export const usePopup: (props?: usePopupProps) => usePopupReturnProps = (
    props = {}
) => {
    const [state, setState] = React.useState(
        props.defaultState ? props.defaultState : false
    )

    const open = () => {
        setState(true)
    }

    const close = () => {
        setState(false)
        props.closeFocusId
            ? document.getElementById(props.closeFocusId).focus()
            : void 0
    }

    const toggle = () => {
        setState(!state)
    }

    return {
        closeFocusId: props.closeFocusId ?? '',
        state: state,
        open: open,
        close: close,
        toggle: toggle,
    }
}
